import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { JudicialRecordPage } from '@/pages/judicial/JudicialRecordPage'

export const Route = createFileRoute('/judicial/$recordId/')({
  component: withErrorBoundary(JudicialRecordPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
